import * as types from "../action-types";
import { reqStaffInfo } from "@/api/staff";
import { clearLocalDatas } from "@/utils/auth";

// 获取用户信息action
export const getUserInfo = (token) => (dispatch) => {
  
  return new Promise((resolve, reject) => {
    // 直接传递token作为参数，而不是包装在对象中
    reqStaffInfo(token)
      .then((response) => {
        
        if (response && response.status === 0) {
          const userInfo = response.userInfo;
          
          // 更新用户信息到Redux状态
          dispatch(setUserInfo(userInfo));
          resolve(response);
        } else {
          const msg = response?.message || "获取用户信息失败";
          
          // 清除无效token
          clearLocalDatas(["token"]);
          reject(msg);
        }
      })
      .catch((error) => {
        
        // 清除无效token
        clearLocalDatas(["token"]);
        reject(error);
      });
  });
};

// 设置用户token
export const setUserToken = (token) => {
  return {
    type: types.USER_SET_USER_TOKEN,
    token,
  };
};

// 设置用户信息
export const setUserInfo = (userInfo) => {
  return {
    type: types.USER_SET_USER_INFO,
    ...userInfo,
  };
};

// 重置用户状态
export const resetUser = () => {
  return {
    type: types.USER_RESET_USER,
  };
};
